import React from "react";
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Card,
  CardContent,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import AddProfileName from "./AddProfileName";
import ShippingProducts from "./ShippingProducts";
import ShippingFrom from "./ShippingFrom";
import ShippingTo from "./ShippingTo";
import { ShippingContextType, ShipProfileContext } from "./ShippingProfile";

interface ShiipingZoneProps {
  handleClose: any;
}
const AddShippingProfile: React.FunctionComponent<ShiipingZoneProps> = ({
  handleClose,
}) => {
  const { profile, setProfile } = React.useContext(
    ShipProfileContext
  ) as ShippingContextType;
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const steps = [
    {
      label: "Profile Name",
      component: (
        <AddProfileName handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Add Products",
      component: (
        <ShippingProducts handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Shipping From",
      component: (
        <ShippingFrom handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Shipping To",
      component: <ShippingTo handleBack={handleBack} />,
      isRequired: true,
    },
  ];

  return (
    <Card>
      <CardContent>
        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={activeStep}>
            {steps.map((item, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={item.label} {...stepProps} disabled>
                  <StepLabel {...labelProps}>{item.label}</StepLabel>
                  {/* <StepButton>butoon</StepButton> */}
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                {steps[activeStep].component}
              </Typography>
            </React.Fragment>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AddShippingProfile;
